import { render } from "./MiBreadcrumbs.vue?vue&type=template&id=47ed567b&scoped=true"
import script from "./MiBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./MiBreadcrumbs.vue?vue&type=script&lang=js"

import "./MiBreadcrumbs.vue?vue&type=style&index=0&id=47ed567b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ed567b"]])

export default __exports__
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBreadcrumbs,QBreadcrumbsEl});
